<template>
	<main>
		<div class="wrapper-form">
			<CardForm :card-title="getString('reset_password')" :card-body="getString('reset_password_info')" :cta-text="getString('reset_password_email_sent')" :cta-done="ctaDone" @cta-click="ctaDone = false" cta-exists>
				<div>
					<div>
						<AppTextInput type="email" ref="email" :label="getString('email')" :placeholder="getString('email')" @pressed-enter="pressedEnterEmail" />
					</div>
					<div class="mt-20">
						<AppTextInput type="password" ref="new-password" :label="getString('new_password')" :placeholder="getString('password')" @pressed-enter="$refs && $refs['new-password'] && $refs['repeat-password'] && $refs['new-password'].currentValue.length > 7 ? $refs['repeat-password'].focus() : null" />
					</div>
					<div class="mt-20">
						<AppTextInput type="password" ref="repeat-password" :label="getString('repeat_password')" :placeholder="getString('password')" @pressed-enter="() => {isCaptchaReady && !loadingEmail ? submitReset() : null}" />
					</div>
					<div class="mt-20">
						<AppButton @click="submitReset" :text="getString('reset')" :disabled="!isCaptchaReady" :loading="loadingEmail" />
					</div>
				</div>
				<div class="links-list mt-30">
					<p class="mb-5">{{ getString('not_registered_question') }} <a :href="linkSignup">{{ getString('signup_here') }}</a></p>
					<p>{{ getString('or') }} <a :href="linkLogin">{{ getString('login_here') }}</a></p>
				</div>
			</CardForm>
		</div>
	</main>
	<AppPopup
		ref="popup-go-signup"
		:buttons="buttonsPopup"
		:title="getString('unattached_email')"
		:bodyText="getString('user_missing_info')" >
	</AppPopup>
	<AppNotification ref="password-dont-match" :title="getString('error')" :body-text="getString('passwords_dont_match')" :type="-2" />
	<AppNotification ref="invalid-email" :title="getString('error')" :body-text="getString('invalid_email')" :type="-2" />
	<AppNotification ref="password-too-short" :title="getString('error')" :body-text="getString('password_too_short')" :type="-2" />
	<AppNotification ref="captcha-failed" :title="getString('error')" :body-text="getString('captcha_failed')" :type="-2" />
	<AppNotification ref="too-many-mails" :title="getString('error')" :body-text="getString('too_many_mails')" :type="-2" />
	<AppNotification ref="email-fail" :title="getString('error')" :body-text="getString('email_fail')" :type="-2" />
	<AppNotification ref="password-too-short-super-user" :title="getString('error')" :body-text="getString('password_too_short_super_user')" :type="-2" :duration="8000" />
	<AppNotification ref="error-generic" :title="getString('error')" :body-text="getString('error_generic')" :type="-2" />
	<AppNotification ref="confirm-mail-sent" :title="getString('success')" :body-text="getString('confirm_mail_sent')" :type="1" :duration="8000" />
</template>

<script>

import {useLanguageStore, useScriptStore} from "@/shared/stores";
import langObject from "@/console-reset/assets/json/langs.json";
import langObjectAuto from "@/console-reset/assets/json/auto.json";
import CardForm from "@/console-reset/components/CardForm.vue";
import API from "@/shared/helpers/API";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppButton from "@/shared/components/AppButton.vue";
import {validateEmail} from "@/shared/helpers/strings";
import AppPopup from "@/shared/components/AppPopup.vue";
import AppNotification from "@/shared/components/AppNotification.vue";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const scriptStore = useScriptStore();
		return {languageStore, getString: languageStore.getString, scriptStore};
	},
	name: "App",
	components: {AppNotification, AppPopup, AppButton, AppTextInput, CardForm},
	data() {
		return {
			isCaptchaReady: false,
			loadingEmail: false,
			ctaDone: false,
		}
	},
	computed: {
		buttonsPopup() {
			let email = this.$refs && this.$refs.email ? encodeURIComponent(this.$refs.email.currentValue) : null;
			return [
				{text: this.getString('cancel'), negative: true},
				{text: this.getString('signup'), callback: () => {
					if(email) {
						window.location.replace(URL_HTML+"/console/signup/?email="+email)
					} else {
						window.location.replace(URL_HTML+"/console/signup/")
					}
				}}
			];
		},
		linkSignup() {
			return URL_HTML+'/console/signup/';
		},
		linkLogin() {
			return URL_HTML+'/console/login/';
		}
	},
	methods: {
		pressedEnterEmail(value) {
			if(this.$refs && this.$refs['new-password'] && validateEmail(value)) {
				this.$refs['new-password'].focus()
			}
		},
		submitReset() {

			let email = this.$refs.email.currentValue;

			if(validateEmail(email)) {

				let newPassword = this.$refs['new-password'].currentValue;
				let repeatPassword = this.$refs['repeat-password'].currentValue;

				if(newPassword.length > 7) {

					if (newPassword === repeatPassword) {

						grecaptcha.execute('6Lc_oK8ZAAAAAHHQSZ2DkU3Ja-jCDML2hqpuIBuC', {action: 'signup'}).then((token) => {

							this.loadingEmail = true;
							API.init().resetPassword(email, newPassword, token, "it", (response) => {
								this.loadingEmail = false;
								if(response && response.result === 'OK') {
									this.$refs["confirm-mail-sent"].openNotification();
									this.$refs['new-password'].currentValue = "";
									this.$refs['repeat-password'].currentValue = "";
									this.ctaDone = true;
								} else if(response && response.details) {
									if(response.details === "captcha") {
										this.$refs["captcha-failed"].openNotification();
									} else if(response.details === "not_registered") {
										this.$refs["popup-go-signup"].toggleStatus(true);
									} else if(response.details === "too_many_emails") {
										this.$refs["too-many-mails"].openNotification();
									} else if(["bouncer_undeliverable", "bouncer_risky", "bounced"].includes(response.details)) {
										this.$refs["invalid-email"].openNotification();
									} else if(response.details === "email_fail") {
										this.$refs["email-fail"].openNotification();
									} else if(response.details === "password_too_short") {
										this.$refs["password-too-short-super-user"].openNotification();
									} else {
										this.$refs["error-generic"].openNotification();
									}
								} else {
									this.$refs["error-generic"].openNotification();
								}
							});

						});


					} else {
						this.$refs["password-dont-match"].openNotification();
					}

				} else {
					this.$refs["password-too-short"].openNotification();
				}

			} else {
				this.$refs["invalid-email"].openNotification();
			}
		},
	},
	created() {
		this.languageStore.addStrings(langObject, "reset-password", langObjectAuto);
		API.init(URL_HTML, URL_HTML+"/console/login/");

		this.scriptStore.loadScript("captcha", () => {

			if(typeof grecaptcha !== "undefined") {
				grecaptcha.ready(() => {
					this.isCaptchaReady = true;
				});
			} else {
				console.error("captcha undefined")
			}

		});
		document.addEventListener('dblclick', function(event) {
			event.preventDefault();
		}, { passive: false });
	},
}
</script>

<style lang="scss">
.grecaptcha-badge {
	display: none;
}
</style>
<style lang="scss" scoped>
	main {
		background-color: #f9fafd;
		.wrapper-form {
			position: relative;
			width: 100%;
			min-height: 100vh;
			padding: 40px 20px 80px;
			display: flex;
			justify-content: center;
			align-items: center;
			@media(max-width: 300px) {
				padding: 12px;
			}

			.links-list {
				p {
					font-size: 14px;
				}
			}
		}
	}
</style>